<template>
    <base-dialog :value="dialog" :title="title" :width="640" :fullscreen="isMobile" @input="onDialogInput"
        @close="hide">
        <routine-preview v-if="assignedRoutine" :routine="assignedRoutine" :name-label="nameLabel" hide-name
            :date-text="nameLabel != null ? '' : null" @start="toRoutineDetail" />
    </base-dialog>
</template>

<script>

import BaseDialog from "@/components/common/BaseDialog";
import RoutinePreview from "@/components/student/RoutinePreview";

export default {
    name: "RoutineDetailDialog",
    components: { BaseDialog, RoutinePreview },
    data() {
        return {
            dialog: false,
            assignedRoutine: null,
            nameLabel: null,
        }
    },
    computed: {
        routineName(vm = this) {
            return vm.assignedRoutine?.name || vm.assignedRoutine?.versus || ''
        },
        title(vm = this) {
            return vm.nameLabel != null ? vm.nameLabel : vm.routineName
        },
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            setTimeout(() => vm.reset(), 300)
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.assignedRoutine = null
            vm.nameLabel = null
        },
        setRoutine(routine, nameLabel = null) {
            const vm = this
            vm.assignedRoutine = routine
            vm.nameLabel = nameLabel
        },
        toRoutineDetail() {
            const vm = this
            if (!vm.assignedRoutine) return null
            vm.pushRoute({ name: 'student.routine.detail', params: { uid: vm.assignedRoutine.id } })
        },
    },
}
</script>
